<template>
    <div class="container">
        <div style="margin-top: 50px">
            <button class="btn_go" @click="goMiniProject">前往小程序</button>
        </div>
    </div>
</template>


<script>

export default {
    data() {
        return {

        }
    },
    created() {
        this.goMiniProject();
    },
    methods: {
        goMiniProject() {
            console.log('goMiniProject');
            window.location.href = 'https://wxaurl.cn/7dBkonNw6Ta'
        }
    }
};
</script>

<style scoped>
.btn_go {
    width: 300px;
    height: 100px;
    background-color: green;
    color: white;
    font-size: 24px;
}
</style>